module.exports = __webpack_public_path__ + "static/img/6areaB_8.65db90c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_8.png
// module id = 1211
// module chunks = 1